import addStylesheet from "../../utils/addStylesheet";
import {
    userSettings
} from '@/globals/userSettings';
import { generateCSSFromConfig } from "../../utils/cssGenerator"
import { FILTERS, SVG_FILTERS } from "../../enum/Filters";

export default function renderFilter() {
    let { states } = userSettings
    let { contrast } = states;

    console.log(contrast);

    // Inject SVG filters if not present
    if (!document.getElementById('asw-filters-svg')) {
        const div = document.createElement('div');
        div.id = 'asw-filters-svg';
        div.style.display = 'none';
        div.innerHTML = SVG_FILTERS;

        // Insert at the very top of body
        document.body.insertBefore(div, document.body.firstChild);
    }

    let css = "";

    let filter = FILTERS[contrast];

    if (filter) {
        css = generateCSSFromConfig({
            ...filter,
            selector: `html.aws-filter`
        })
    }

    console.log("css", css)

    addStylesheet({
        css,
        id: 'asw-filter-style'
    });

    document.documentElement.classList.toggle("aws-filter", Boolean(contrast));
}